import pocmanLogo from "../../assets/logo-pocman.png";

const PocmanLogo = () => {
    return (
        <img src={pocmanLogo} alt="The pocman" width="158" height='48'/>
    )
}

export default PocmanLogo;